module.exports = __webpack_public_path__ + "assets/img/34_706_big.c59da5d1.jpg";